import LongTextCell from "../LongTextCell"


const useAssessmentNameCell = () => {

    const assessmentNameCell = {
        accessorKey: 'reading_assessment_name',
        header: "שם המבדק",
        cell: LongTextCell
    }

    return assessmentNameCell
}

export default useAssessmentNameCell